var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 27 29","fill":"none","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":""}},[_c('path',{attrs:{"d":"M27 14.5L0.749999 28.7894L0.75 0.21058L27 14.5Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }